import remotesConfig from 'remotesConfig'
import veStoreMfeConfig from 'veStoreMfeConfig'
import injectWindowVariables from '@ve/module-federation/injectWindowVariables'
import injectScripts from '@ve/module-federation/injectScripts'
if (veStoreMfeConfig?.maintenance?.enabled) {
  injectWindowVariables(remotesConfig)
  import('./bootstrap')
} else {
  injectWindowVariables(remotesConfig)
  injectScripts(remotesConfig)
  import('./bootstrap')
}
export {}
